import config from "../../assets/js/conf/config";
import request from "../../assets/js/utils/request";
import axios from "axios";

/** 微信小店店铺列表 */
export function getShopList(data) {
	return request.get(config.baseApiB + "/api/v1/wxshop/shop/list", data || {})
}

/** 订单列表 */
export function getOrderList(data) {
	return request.get(config.baseApiB + "/api/v1/wxshop/order/list", data || {})
}

/** 同步进度 */
export function getSyncStatus(data) {
	return request.get(config.baseApiB + "/api/v1/wxshop/order/sync/status", data || {})
}

/** 手动同步 */
export function postOrderSync(data) {
	return request.post(config.baseApiB + "/api/v1/wxshop/order/sync", data || {})
}

/** 单条同步微店订单 */
export function postOrderRefresh(data) {
	return request.post(config.baseApiB + "/api/v1/wxshop/order/refresh", data || {})
}

/** 批量导出订单 */
export function postOrderExport(data) {
	return request.post(config.baseApiB + "/api/v1/wxshop/order/export", data || {})
}

/** 解密收货信息（兼容旧入口） */
export function postOrderDecode(data) {
	return request.post(config.baseApiB + "/api/v1/wxshop/order/decode", data || {})
}

/** 查询可编辑买家收货信息 */
export function getDeliveryAddress(data) {
	return request.get(config.baseApiB + "/api/v1/wxshop/order/delivery-address", data || {})
}

/** 人工保存买家收货信息 */
export function postDeliveryAddress(data) {
	return request.post(config.baseApiB + "/api/v1/wxshop/order/delivery-address", data || {})
}

/** 智能识别收货地址 */
export function postExplainAddress(data) {
	return request.post(config.baseApiB + "/api/v1/wxshop/order/explain-address", data || {})
}

/** 查询采购单退货地址（弹窗） */
export function getReturnAddress(data) {
	return request.get(config.baseApiB + "/api/v1/wxshop/order/return-address", data || {})
}

/** 保存采购单退货地址 */
export function postReturnAddress(data) {
	return request.post(config.baseApiB + "/api/v1/wxshop/order/return-address", data || {})
}

/** 省市区子级（parent_code=0 为省） */
export function getAddressCodeChildren(data) {
	return request.get(config.baseApiB + "/api/v1/wxshop/address-code/children", data || {})
}

/** 修改商家备注 */
export function postMerchantNotes(data) {
	return request.post(config.baseApiB + "/api/v1/wxshop/order/merchant-notes", data || {})
}

/** 标记问题订单 */
export function postMarkProblem(data) {
	return request.post(config.baseApiB + "/api/v1/wxshop/order/mark-problem", data || {})
}

/** 标记/取消异常订单 */
export function postMarkException(data) {
	return request.post(config.baseApiB + "/api/v1/wxshop/order/mark-exception", data || {})
}

/** 买家地址导入进度 */
export function getAddressImportProgress(data) {
	return request.get(config.baseApiB + "/api/v1/wxshop/order/address-import/progress", data || {})
}

/** 导入买家信息表格 */
export function postAddressImport(file) {
	const token = localStorage.getItem(config.tokenKey)
	const form = new FormData()
	form.append('file', file)
	return axios({
		url: config.baseApiB + "/api/v1/wxshop/order/address-import",
		method: 'post',
		headers: {
			Authorization: `Bearer ${token}`,
		},
		data: form,
		timeout: 120000,
	}).then(res => {
		const data = res.data || {}
		data.msg = data.msg || data.message
		return data
	})
}
